<template>
  <v-skeleton-loader
    v-if="!text"
    v-bind="$attrs"
    :type="type"
    color="transparent"
    gutters="0"
    class="text-skeleton"
    :loading="isLoading"
  >
      <slot name="default"></slot>
  </v-skeleton-loader>
  <slot v-else name="default"><span>{{text}}</span></slot>
</template>

<script>
import {computed} from "vue";

export default {
  name: "TextSkeleton",
  props: {
    text: {type: String, default: ""},
    type: {type: String, default: "text"},
    loading: {type: Boolean, default: false},
  },
  setup(props, { emit }) {
      const isLoading = computed(() => props.loading);

      return {
          isLoading
      }
  }
};
</script>

<style>
.text-skeleton .v-skeleton-loader__text {
  margin: 0;
}
</style>
